import request from '@/utils/request';
import qs from 'qs';
export function getStockRanking(data) {
  return request({
    baseURL: '/chaos/api',
    url: '/v1/stock/ranking',
    method: 'post',
    data: data
  })
}


// 获取股票用户排行

export function getStockUserRanking(data) {
  return request({
    baseURL: '/chaos/api',
    url: '/v1/stock/user/ranking',
    method: 'post',
    data: data
  })
}


// 获取股票用户排行

export function getDonateUserRanking(data) {
  return request({
    baseURL: '/chaos/api',
    url: '/v1/donate/income/ranking',
    method: 'post',
    data: data
  })
}

// 关注 ➕
export function fetchAppRelation(data) {
  return request({
    url: '/appRelation/save',
    method: 'post',
    // data: data
    data: qs.stringify(data),
    header: {
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8;'
    }
    // params: query
  })
}

//  取消关注
export function fetchAppRelationDelete(data) {
  return request({
    url: '/appRelation/delete',
    method: 'post',
    // data: data
    data: qs.stringify(data),
    header: {
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8;'
    }
    // params: query
  })
}

// 我的活动分期奖励列表
export function fetchAwardList(data) {
  return request({
    baseURL: '/chaos/api',
    url: '/v1/activity/term/award/list',
    method: 'post',
    data: data

  })
}

// 我的活动分期奖励列表
export function fetchAwardLast(data) {
  return request({
    baseURL: '/chaos/api',
    url: '/v1/activity/term/award/last',
    method: 'post',
    data: data
  })
}


export function saveAddrInfo(data) {
  return request({
    baseURL: '/chaos/api',
    url: '/v1/recipient/address',
    method: 'post',
    data
  })
}




export function getAddrInfo(data) {
  return request({
    baseURL: '/chaos/api',
    url: '/v1/recipient/address',
    method: 'get',
    params: data
  })
}



export function fetchTopicList(data) {
  return request({
    baseURL: '/chaos/api',
    url: '/v1/topic/recommend/list',
    method: 'post',
    data: data
  })
}



export function fetchComplexranking(data) {
  return request({
    baseURL: '/chaos/api',
    url: '/v1/stock/getcomplexranking',
    method: 'post',
    data: data
  })
}

// 参加活动 3 倍积分复制接口复制文档复制地址
// POST
// /chaos/api/v1/activity/participate
// 请求数据类型application/json


export function fetchParticipate(data) {
  return request({
    baseURL: '/chaos/api',
    url: '/v1/activity/participate',
    method: 'post',
    data: data
  })
}

// 是否参加了 3 倍积分活动
export function fetchHasparticipate(data) {
  return request({
    baseURL: '/chaos/api',
    url: '/v1/activity/hasparticipate',
    method: 'post',
    data: data
  })
}


// /stock/getcomplexranking

// /chaos/api/v1/activity/term/award/list


// WEBPACK FOOTER //
// ./src/views/activity_130/api.js